module.exports = __webpack_public_path__ + "static/media/Anran.7bdca682.png";